import React from 'react';
import { useTranslation } from '@tasama/i18n';
import { Messages } from '@tasama/ui';
import { EXTERNAL_ROUTES } from '@tasama/config';
interface ConfirmationProps {
  /** Test ID for QA automation */
  testID?: string | undefined;
}

/**
 * Confirmation screen component for the onboarding flow
 *
 * Based on Figma design: https://www.figma.com/design/IcSV9qhrjLJh6Y3Q8F7lcr/Tasama-UI-UX-Design?node-id=1764-46903&m=dev
 *
 * Features:
 * - Success message with 3D icon
 * - Thank you message and follow-up information
 * - Done button with check-circle icon
 * - Follows React 19 patterns with useTransition
 * - Maintains consistency with existing onboarding pages
 * - Uses design tokens from the UI package
 * - Implements Atomic Design principles
 */
const Confirmation: React.FC<ConfirmationProps> = ({
  testID = 'confirmation-screen',
}) => {
  const { t } = useTranslation('onboarding');
  const description = (
    <>
      {t('confirmation.followUpMessage')}
      <br />
      {t('confirmation.supportPrefix')}{' '}
      <a
        href={EXTERNAL_ROUTES.CONTACT_ME}
        target="_blank"
        rel="noopener noreferrer"
        className="text-fg-brand-primary font-light text-[16px] leading-[24px] underline decoration-solid decoration-auto underline-offset-auto"
      >
        {t('confirmation.supportLinkText')}
      </a>
      .
    </>
  );

  return (
    <>
      {/* Main Content - Messages Component */}
      <div className="flex-1 flex flex-col items-center justify-center gap-8">
        <Messages
          type="default"
          title={t('confirmation.title')}
          description={description}
          testID={`${testID}-message`}
          className="text-center"
        />
      </div>
    </>
  );
};

Confirmation.displayName = 'Confirmation';

export default Confirmation;
export type { ConfirmationProps };
